module.exports = __webpack_public_path__ + "img/ml.59fb7c2a.jpg";